import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"filter-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 8C16.6944 8 20.5 6.88071 20.5 5.5V6L14 14V17C14 19.2091 12.2091 21 10 21V14L3.5 6V5.5C3.5 6.88071 7.30558 8 12 8Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M20.5 5.5C20.5 6.88071 16.6944 8 12 8C7.30558 8 3.5 6.88071 3.5 5.5C3.5 4.11929 7.30558 3 12 3C16.6944 3 20.5 4.11929 20.5 5.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20.5 5.5C20.5 6.88071 16.6944 8 12 8C7.30558 8 3.5 6.88071 3.5 5.5M20.5 5.5C20.5 4.11929 16.6944 3 12 3C7.30558 3 3.5 4.11929 3.5 5.5M20.5 5.5V6L14 14V17C14 19.2091 12.2091 21 10 21V14L3.5 6V5.5","strokeWidth":"props.strokeWidth"}}]}]};

const Filter1 = Vue.extend<IconProps>({
  name: 'Filter1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'filter-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Filter1;
